import { Tooltip } from "@mui/material";
import { InfoIconSvg } from "../../utils/svg-components";

const InfoIcon = (props) => {
  const { message, icon, placement = "top" } = props;
  return (
    <div>
      <Tooltip
        arrow
        title={
          <div className="tooltip-padding" style={{ fontSize: "13px" }}>
            {message}
          </div>
        }
        classes={{
          tooltip: "desc-tooltip-tile no-padding",
          arrow: "desc-tooltip-arrow",
        }}
        placement={placement}
      >
        {icon ? (
          icon
        ) : (
          <span>
            <InfoIconSvg />
          </span>
        )}
      </Tooltip>
    </div>
  );
};

export default InfoIcon;
